import { IdiomaService } from './../providers/idioma/idioma.service';
import { Component, EventEmitter, Input, Output, OnDestroy } from '@angular/core';
import { EntityManagerProvider } from '../providers/entity-manager-provider/entity-manager-provider';
import { AuthenticationService } from '../providers/authentication/authentication.service';
import { TranslateService } from 'ng2-translate';
import { AppComponent } from '../app.component';
import { ServiciosWebServiceProvider } from '../providers/web-service-service/servicios-web-service';
import { PermisosService, Permisos } from '../providers/authentication/permisos.service';
import { Idioma } from '../domain/Idioma';
import { IdiomaCalendario } from '../domain/IdiomaCalendatio';
import { BalizaFormulario } from '../domain/BalizaFormulario';

@Component({
  selector: 'app-formulario-baliza',
  templateUrl: './FormularioBaliza.component.html'
})

export class FormularioBalizaComponent implements OnDestroy{

  @Input() balizaSeleccionado: BalizaFormulario;
  @Input() confirmacionVisible: boolean;
  @Input() msgs: any[];
  @Input() visible: boolean = true;
  @Input() idHardwareBalizas: string[];


  @Output() onElementoGuardado: EventEmitter <any> = new EventEmitter();
  @Output() onElementoError: EventEmitter <any> = new EventEmitter();
  @Output() onElementoEliminado: EventEmitter <any> = new EventEmitter();
  @Output() onFormularioValidation: EventEmitter <boolean> = new EventEmitter();

  public isValid = true;
  public color;

  public operacion;

	/* IDIOMA */
	idiomas;
	idiomaSeleccionado: Idioma;
	idiomaDefecto: Idioma;
	idiomaCalendario: IdiomaCalendario;

  blockUI: HTMLElement;
  spinner: HTMLElement;
  permisos: Permisos = new Permisos();

  public fAltaError = false;
  public fBajaError = false;
	tipologiasBaliza: any;

  constructor(
	private appComponent: AppComponent,
      private entityManagerProvider: EntityManagerProvider,
	  public authService: AuthenticationService,
	  public idiomaService: IdiomaService,
	  public sws: ServiciosWebServiceProvider,
	  private translate: TranslateService,
	  private permisosService: PermisosService
	) {
		const that = this;
		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';

		this.blockUI = document.getElementsByClassName('blockPosicionarBaliza')[0] as HTMLElement;
		if (this.blockUI) {
			this.blockUI.style.display = 'none';
		}

		this.entityManagerProvider.getIDIOMA()
		.then(function (idiomasENTIDAD: any) {

			that.idiomas = [];
			idiomasENTIDAD.forEach(idioma => {
				if(idioma.Visible === true){
				that.idiomas.push(new Idioma(idioma));
				}
			});

			that.idiomaDefecto = idiomaService.getIdiomaDefecto(that.idiomas);
			that.idiomaSeleccionado = that.idiomaDefecto;
			const includes = undefined;
			const where = undefined;
			return that.obtenerTIPOLOGIA_BALIZA();
		});

		this.comprobarPermisos();
		console.log(this.idHardwareBalizas)

		this.idiomaCalendario = new IdiomaCalendario();
		this.idiomaCalendario.firstDayOfWeek = 1;
		this.idiomaCalendario.dayNames = this.translate.instant('Calendario.dayNames');
		this.idiomaCalendario.dayNamesShort = this.translate.instant('Calendario.dayNamesShort');
		this.idiomaCalendario.dayNamesMin = this.translate.instant('Calendario.dayNamesMin');
		this.idiomaCalendario.monthNames = this.translate.instant('Calendario.monthNames');
		this.idiomaCalendario.monthNamesShort = this.translate.instant('Calendario.monthNamesShort');
		this.idiomaCalendario.today = this.translate.instant('Calendario.today');
		this.idiomaCalendario.clear = this.translate.instant('Calendario.clear');
		this.msgs = [];
	}

	ngOnDestroy(): void {
		this.msgs = [];
		this.entityManagerProvider.RejectChanges();
	}

	/* Confirmacion */
	mostrarConfirmacion(operacion){
		this.appComponent.showWarn(operacion);
		this.operacion = operacion;
		this.confirmacionVisible = true;
	}

	confirmar(){
		this.msgs = [];
		if (this.operacion === 'guardar') {
			this.spinner.style.display = 'inherit';
			this.guardar();
		}
		else if (this.operacion === 'eliminar'){
			this.eliminar();
		}
	}

	cancelar(){
		this.msgs = [];
		this.operacion = '';
		this.confirmacionVisible = false;
	}

	public validar(): boolean {
		console.warn('Implementar: validar');
		
		if (!this.balizaSeleccionado.IdHardware) {
			this.isValid = false;
		}
		else if(this.idHardwareBalizas.includes(this.balizaSeleccionado.IdHardware) === true && this.balizaSeleccionado.IdHardware !== this.balizaSeleccionado.ENTIDAD.IdHardware){
			this.isValid = false;
			this.msgs.push({ severity: 'error', summary: this.translate.instant('Beacons.nombreDuplicado'), detail: this.translate.instant('Beacons.nombreDuplicado') });
		}else {
			this.isValid = true;
		}

		this.onFormularioValidation.emit(this.isValid);

		return this.isValid;
	}

	public guardar(): any {
		if (this.validar()) {
			this.guardarBaliza();

		} else {
			this.spinner.style.display = 'none';
			this.appComponent.showError(this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO'));
			this.confirmacionVisible = false;
			console.log(this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO'));
		}
	}


	guardarBaliza(){

		this.balizaSeleccionado.ENTIDAD.X = this.balizaSeleccionado.X;
		this.balizaSeleccionado.ENTIDAD.Y = this.balizaSeleccionado.Y;
		this.balizaSeleccionado.ENTIDAD.IdHardware = this.balizaSeleccionado.IdHardware;
		this.balizaSeleccionado.ENTIDAD.DescInstalacion = this.balizaSeleccionado.DescInstalacion;
		this.balizaSeleccionado.ENTIDAD.PasswordBeacons = this.balizaSeleccionado.PasswordBeacons;

		this.balizaSeleccionado.ENTIDAD.FechaAlta = this.balizaSeleccionado.FechaAlta;
		this.balizaSeleccionado.ENTIDAD.FechaBaja = this.balizaSeleccionado.FechaBaja;
		this.balizaSeleccionado.ENTIDAD.FechaInstalacion = this.balizaSeleccionado.FechaInstalacion;

		this.balizaSeleccionado.ENTIDAD.TIPOLOGIA_BALIZA = this.balizaSeleccionado.TIPOLOGIA_BALIZA;
		
		if(this.balizaSeleccionado.ENTIDAD.TIPOLOGIA_BALIZA.esBeacon){
			this.balizaSeleccionado.IconoRepresentacion = 'assets/itsoft/IconosSVG/SVG/' + 'nodo-baliza.svg';
			this.balizaSeleccionado.ENTIDAD.IconoRepresentacion = this.balizaSeleccionado.IconoRepresentacion;
		}
		if(this.balizaSeleccionado.ENTIDAD.TIPOLOGIA_BALIZA.esSniffer){
			this.balizaSeleccionado.IconoRepresentacion = 'assets/itsoft/IconosSVG/SVG/' + 'nodo-snifer.svg';
			this.balizaSeleccionado.ENTIDAD.IconoRepresentacion = this.balizaSeleccionado.IconoRepresentacion;
		}
		if(this.balizaSeleccionado.ENTIDAD.TIPOLOGIA_BALIZA.esTag){
			this.balizaSeleccionado.IconoRepresentacion = 'assets/itsoft/IconosSVG/SVG/' + 'nodo-tag.svg';
			this.balizaSeleccionado.ENTIDAD.IconoRepresentacion = this.balizaSeleccionado.IconoRepresentacion;
		}

		// No editable:
		// this.balizaSeleccionado.ENTIDAD.NivelBateria = this.balizaSeleccionado.NivelBateria;
		// this.balizaSeleccionado.ENTIDAD.potenciaTx = this.balizaSeleccionado.potenciaTx;
		// this.balizaSeleccionado.ENTIDAD.TimestampLecturaBateria = this.balizaSeleccionado.TimestampLecturaBateria;

		this.confirmacionVisible = false;

		const that = this;
		const token = that.authService.getToken();
		const idEspacio = that.authService.getIdEspacio();

		const idAla = this.balizaSeleccionado.ENTIDAD.ALA_PLANO ? this.balizaSeleccionado.ENTIDAD.ALA_PLANO.Id : "";
		return that.sws.wsObtenerLLFromXY(token, that.balizaSeleccionado.X, that.balizaSeleccionado.Y, idEspacio, idAla).toPromise()
		// return that.entityManagerProvider.saveChanges()
		.then(function (ll) {
			console.log(ll)
			that.balizaSeleccionado.ENTIDAD.Latitud = ll.Latitud;
			that.balizaSeleccionado.ENTIDAD.Longitud = ll.Longitud;

			return that.entityManagerProvider.saveChanges();
		})
		.then(function(data: any) {
			console.log(data)
			// Renovamos el Token
			if(data){

					that.authService.relogin();
					that.onElementoGuardado.emit({ result: true, element: that.balizaSeleccionado });
					that.spinner.style.display = 'none';
				
			}else{
				that.onElementoGuardado.emit({ result: false, element: that.balizaSeleccionado });
				that.spinner.style.display = 'none';
			}
		})
		.catch(function(err) {
			console.log(err)
			console.log('aqui')
			that.onElementoGuardado.emit({ result: false, element: that.balizaSeleccionado });
			that.spinner.style.display = 'none';
			return err;
		});
	}

	public eliminar() {
		this.spinner.style.display = 'inherit';
		const that = this;
		this.confirmacionVisible = false;

		this.eliminarSeleccionado()
		.then(function () {
			that.spinner.style.display = 'none';
			that.onElementoEliminado.emit({ result: true, element: that.balizaSeleccionado });
			that.authService.relogin();
		})
		.catch(function () {
			that.spinner.style.display = 'none';
			that.onElementoEliminado.emit({ result: false, element: that.balizaSeleccionado });
		});
	}

	public eliminarSeleccionado () {
		const that = this;
		if (this.balizaSeleccionado !== undefined) {
			return this.entityManagerProvider.deleteBALIZA(this.balizaSeleccionado.ENTIDAD);
		}
	}

	aplicar(){
		this.blockUI = document.getElementsByClassName('blockPosicionarBaliza')[0] as HTMLElement;
		this.blockUI.style.display = 'inherit';
	}

	posicionar(){
		this.blockUI = document.getElementsByClassName('blockPosicionarBaliza')[0] as HTMLElement;
		this.blockUI.style.display = 'none';
	}

	comprobarPermisos() {
		const userId = this.authService.getIdUsuario();
		const that = this;
		return this.permisosService.getPermisosUsuario(userId)
		.then(function(perm){
			that.permisos = perm;
		});
	}


	obtenerTIPOLOGIA_BALIZA() {
		const that = this;
		const entityManager = that.entityManagerProvider;
		return entityManager.getTIPOLOGIA_BALIZA(undefined, undefined)
			.then(function (entidades) {
				that.tipologiasBaliza = entidades;

				that.tipologiasBaliza = entidades;
				if (that.tipologiasBaliza && that.tipologiasBaliza.length > 0) {
					that.tipologiasBaliza.sort((one: any, two: any) => {
						return one.Nombre > two.Nombre ? 1 : -1;
					});
				}
			});
	}

	onFechaAceptar(dt, calendar, columna, tipo) {
		console.log(calendar);
		const fecha = calendar.value ? calendar.value : new Date();
		if (tipo === 'FechaInstalacion') {
			this.balizaSeleccionado.FechaInstalacion = fecha;
		}
		if (tipo === 'FechaLecturaBateria') {
			this.balizaSeleccionado.FechaLecturaBateria = fecha;
		}
		if (tipo === 'FechaAlta') {
			this.balizaSeleccionado.FechaAlta = fecha;
		}
		if (tipo === 'FechaBaja') {
			this.balizaSeleccionado.FechaBaja = fecha;
		}
		calendar.overlayVisible=false;
	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/formularios/FormularioBaliza.component.ts